;(function () {
  'use strict'
  var lightbox

  function init () {
    if (!lightbox) {
      lightbox = document.createElement('div')
      lightbox.className = 'modal'
      lightbox.innerHTML = '<span role="button" aria-label="Close" class="close cursor">&times;</span>\n' +
        '  <div class="modal-content">\n' +
        '    <img alt="filled at runtime">\n' +
        '  </div>'

      var footer = document.getElementsByTagName('footer')[0]
      footer.parentNode.insertBefore(lightbox, footer.nextSibling)

      lightbox.getElementsByTagName('div')[0].onclick = closeModal
      lightbox.getElementsByTagName('span')[0].onclick = closeModal
    }
  }

  function openModal () {
    lightbox.style.display = 'block'
    document.addEventListener('keydown', handleEscape)
  }

  function closeModal () {
    lightbox.style.display = 'none'
    document.removeEventListener('keydown', handleEscape)
  }

  function handleEscape (event) {
    if (event.key === 'Escape') {
      closeModal()
    }
  }

  // exclude images marked as "no-lightbox"
  document.querySelectorAll('.imageblock:not(.no-lightbox) img').forEach(function (element) {
    if (element.parentNode.nodeName === 'A') {
      // if parent node is an anchor, keep the anchor instead of opening lightbox
      return
    }
    element.classList.add('lightbox')
    element.addEventListener('click', function (evt) {
      init()
      lightbox.getElementsByTagName('img')[0].setAttribute('src', evt.currentTarget.getAttribute('src'))
      lightbox.getElementsByTagName('img')[0].setAttribute('alt', evt.currentTarget.getAttribute('alt'))
      openModal()
    })
  })
})()
